<template>
  <v-container class="pa-0" fluid>
    <!-- <material-card icon="mdi-clipboard-text" inline :title="enrollID ? 'Edit Enroll Teachers' : 'Add Enroll Teachers'"> -->
     <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="3" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  {{enrollID ? 'Edit Enroll Teachers' : 'Add Enroll Teachers'}}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      <v-card-actions>
        <router-link slot="right" :to="{ name: 'teacherEnrollment' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <v-card flat class="px-2">
        <v-form ref="form" v-model="valid">
          <v-row>
            <!-- <v-col cols="12" md="6">
              <custom-date-picker prepend-icon="mdi-calendar" v-model="startDate" :min="TrainingFromDate" required />
            </v-col>
            <v-col cols="12" md="6">
              <custom-date-picker prepend-icon="mdi-calendar" v-model="endDate" :min="TrainingFromDate" required />
            </v-col> -->
            <!-- <v-col cols="12" md="6">
              <v-autocomplete label="Select duration" :items="durationList" v-model="formData.durationID" item-text="duration" item-value="id" :hide-details="true"></v-autocomplete>
            </v-col> -->
            <!-- <v-col cols="12" md="6">
              <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="time" aria-required="true" label="Pick Training Time" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-time-picker v-if="menu2" v-model="time" full-width format="24hr" @click:minute="$refs.menu.save(time)"></v-time-picker>
              </v-menu>
            </v-col> -->
            <v-col cols="12" md="6">
<span @click="selectAll" style="cursor:pointer;" v-if="clickedOnSelectAll"><u>Select All</u></span>
<span @click="resetAll" style="cursor:pointer;" v-if="clickedOnResetAll"><u>Reset All</u></span>

            <multiselect
                placeholder="Select Center"
                class="overflowmultiselect2"
                label="companyName"
                track-by="id"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :preselect-first="false"
                :multiple="true"
                :options="franchiseeData"
                v-model="selectedcenters"
@input="onFranchiseeSelect()"
              >
              </multiselect>
<!-- <multiselect getStaffData
                placeholder="Select Teachers"
                class="overflowmultiselect2"
                label="fullName"
                track-by="id"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :preselect-first="false"
                :multiple="true"
                :options="teachersData"
                v-model="selectedStaff"
              >
              </multiselect> -->
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete  v-model="formData.classID" :items="classData" item-text="name" item-value="id" label="Select Class Group" :rules="classRules" @input="getTrainingTopicData()"></v-autocomplete>
            </v-col>
<!-- <v-col cols="12" lg="6" v-if="getList.length > 0"><b>Classes</b> :<br> {{ getList }}</v-col> -->
              <v-col cols="12" lg="6" md="6" v-if="getList.length > 0"><span id="abcd">Classes:</span><br>
              <v-chip-group  column >
                <v-chip small color="accent"
                v-for='name in getList'
                :key="name"
                  >
                  {{ name }}
                </v-chip>
              </v-chip-group>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete hide-details class="my-0 py-1" v-model="formData.trainingID" :items="trainingTopicData" item-text="name" item-value="id" label="Select Training Topic" :rules="classRules"></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" md="6">
              <v-autocomplete v-model="formData.state" :items="stateData" item-text="name" item-value="name" label="Select State" :rules="classRules"></v-autocomplete>
            </v-col> -->
            <!-- <v-col cols="12" md="6">
              <v-text-field label="Enter City" placeholder="Enter your city" v-model="formData.city"></v-text-field>
            </v-col> -->
            <v-col cols="12" md="6">
<span @click="selectAllTeachers" style="cursor:pointer;" v-if="clickedOnTeacherSelectAll"><u>Select All</u></span>
<span @click="resetAllTeachers" style="cursor:pointer;" v-if="clickedOnTeacherResetAll"><u>Reset All</u></span>
              <multiselect
                placeholder="Select Teachers"
                class="overflowmultiselect2"
                label="fullName"
                track-by="id"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :preselect-first="false"
                :multiple="true"
                :options="teachersData"
                v-model="selectedStaff"
              >
              </multiselect>
            </v-col>
            <!-- <v-col cols="12" md="6">
              <v-textarea label="Location" v-model="formData.location" auto-grow rows="2" row-height="15"></v-textarea>
            </v-col> -->

            <v-col cols="12" md="6">
              <v-textarea hide-details class="my-0 py-1" label="Description" clearable clear-icon="mdi-close-circle" v-model="formData.description" auto-grow rows="3" row-height="25"></v-textarea>
            </v-col>

            <v-col cols="12" lg="4" md="4">
              <v-textarea hide-details class="my-0 py-1" clearable clear-icon="mdi-close-circle" label="Remark" v-model="formData.remark" auto-grow rows="3" row-height="25"></v-textarea>
            </v-col>
<v-col cols="12" class="mt-5" lg="2" md="2">
              <v-checkbox hide-details class="my-0 py-1" v-model="formData.isOnline" label="Online"></v-checkbox>
            </v-col>
            <v-col cols="12" class="mt-12" lg="6" md="6">
              <v-card-actions class="d-flex justify-end">
                <v-spacer />
                <v-btn color="primary" @click="onSubmit">
                  Enroll
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
     </v-card>
    <!-- </material-card> -->
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
// import Utils from '@/utils'
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
// import CustomDatePicker from '@/components/template/CustomDatePicker'
// import MaterialCard from '@/components/template/MaterialCard'

export default {
  name: 'TeacherTrainingTopic',
  props: ['enrollID', 'classID', 'trainingID'],
  components: {
    Multiselect

    // CustomDatePicker
  },
  data () {
    return {
      classData: [],
      durationList: [],
      franchiseeData: [],
      trainingTopicData: [],
      stateData: [],
      teachersData: [],
      selectedStaff: [],
      selectedcenters: [],
      selectedStaffTemp: [],
      valid: false,
      getList: [],
      selectAllBtn: '',
      resetAllBtn: '',
      allSelected: false,
      clickedOnResetAll: false,
      clickedOnSelectAll: true,
      clickedOnTeacherResetAll: false,
      clickedOnTeacherSelectAll: true,
      classRules: [v => !!v || 'Item is required'],
      formData: {
        franchiseeID: '',
        classID: '',
        trainingID: '',
        description: '',
        state: '',
        city: '',
        remark: '',
        durationID: 0,
        fromDate: null,
        toDate: null,
        isOnline: false,
        location: '',
        trainingStaffs: []
      },
      isLoading: false,
      time: null,
      menu2: null,
      startDate: null,
      endDate: null,
      TrainingFromDate: new Date().toISOString().slice(0, 10)
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {},
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      await this.getDurationList()
      await this.getClassData()
      await this.getFranchiseeData()
      await this.getStateCityDetails()
      if (this.enrollID) {
        await this.getEnrollDetails(this.enrollID)
      }
      if (this.franchiseeData.length === this.selectedcenters.length) {
        this.clickedOnResetAll = true
        this.clickedOnSelectAll = false
      } else {
        this.clickedOnSelectAll = true
        this.clickedOnResetAll = false
      }
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    onFranchiseeSelect: async function () {
      await this.getStaffData()
    },
    selectAll: async function () {
      this.selectedcenters = this.franchiseeData
      await this.getStaffData()
      this.clickedOnResetAll = true
      this.clickedOnSelectAll = false
    },
    resetAll: function () {
      this.selectedcenters = []
      this.teachersData = []
      this.clickedOnResetAll = false
      this.clickedOnSelectAll = true
    },
    selectAllTeachers: async function () {
      await this.getStaffData()
      if (this.selectedcenters.length > 1) {
        this.clickedOnTeacherResetAll = false
        this.clickedOnTeacherSelectAll = true
      } else {
        this.clickedOnTeacherResetAll = true
        this.clickedOnTeacherSelectAll = false
      }
    },
    resetAllTeachers: function () {
      this.selectedStaff = []
      this.clickedOnTeacherResetAll = false
      this.clickedOnTeacherSelectAll = true
    },
    getDurationList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/online-meeting/get-durations`)
        this.durationList = data
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.errMsg(errorMessage)
      } finally {
      }
    },
    getEnrollDetails: async function (enrollID) {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/teacher-training/request/get/${enrollID}`)
        this.isLoading = false
        if (data) {
          let centerList = _.map(data.trainingRequestFranchiseeMaps, 'franchiseeID')

          let franchiseeList = []
          this.franchiseeData.filter(function (e) {
            if (centerList.includes(e.id)) {
              franchiseeList.push(e)
            }
          })
          this.selectedcenters = franchiseeList

          if (data.trainingRequestFranchiseeMaps) {
            await this.getStaffData()
          }
          this.formData.classID = data.studentClassGroup.id
          if (data.studentClassGroup.id) {
            await this.getTrainingTopicData()
          }
          if (data.training) { this.formData.trainingID = data.training.id }
          // this.formData.trainingID = data.training.id
          this.formData.description = data.description
          this.formData.remark = data.remark ? data.remark : ''
          //   this.formData.state = data.state
          //   this.formData.city = data.city
          //   this.formData.fromDate = moment(data.fromDate).format('YYYY-MM-DD')
          //   this.startDate = moment(data.fromDate).format('YYYY-MM-DD')
          //   this.formData.toDate = moment(data.toDate).format('YYYY-MM-DD')
          //   this.endDate = moment(data.toDate).format('YYYY-MM-DD')
          //   this.time = moment(data.fromDate).format('HH:mm:ss')
          //   this.formData.location = data.location
          this.formData.isOnline = data.isOnline
          //   const selectedDuration = _.filter(this.durationList, d => {
          //     return d.durationInMinutes === data.durationMin
          //   })
          //   this.formData.durationID = selectedDuration[0].id
          _.map(data.trainingRequestStaffMaps, d => {
            let teacherInfo = _.filter(this.teachersData, data => {
              return data.userStaff.id === d.staffID
            })
            if (!_.isEmpty(teacherInfo)) {
              this.selectedStaff.push(teacherInfo[0])
            }
          })
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getStaffData: async function () {
      try {
        this.isLoading = true
        this.selectedStaffTemp = []
        let franchiseeIDs = _.map(this.selectedcenters, 'id')

        if (!_.isEmpty(franchiseeIDs)) {
          this.selectedStaffTemp = this.selectedStaff
        }

        this.teachersData = []
        this.selectedStaff = []

        let { data } = await http.get(`${constants.API_URL}/api/staff/approved?franchiseeID=${franchiseeIDs}&&isTeachingStaff=true`)
        this.isLoading = false
        // data = _.uniq(data, 'user.id')
        _.map(data, d => {
          d.user.fullName = `${d.user.firstName} ${d.user.lastName} (${d.franchisee.companyName})`
          d.user.franchiseeID = d.franchisee.id
          this.teachersData.push(d.user)
        })

        if (this.selectedStaffTemp) {
          let filterDataObj = this.selectedStaffTemp

          let newArr = []
          filterDataObj.filter(function (e) {
            if (franchiseeIDs.includes(e.franchiseeID)) {
              newArr.push(e)
            }
          })
          if (newArr) {
            this.selectedStaff = newArr
          }
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getStaffDataList: async function () {
      try {
        this.isLoading = true
        this.selectedStaffTemp = this.selectedStaff
        this.teachersData = []
        this.selectedStaff = []
        let franchiseeIDs = _.map(this.selectedcenters, 'id')
        let { data } = await http.get(`${constants.API_URL}/api/staff/approved?franchiseeID=${franchiseeIDs}&&isTeachingStaff=true`)
        this.isLoading = false
        // data = _.uniq(data, 'user.id')
        _.map(data, d => {
          d.user.fullName = `${d.user.firstName} ${d.user.lastName} (${d.franchisee.companyName})`
          this.teachersData.push(d.user)
        })
        if (this.teachersData) {
          this.selectedStaff = this.teachersData
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onSubmit: async function () {
      try {
        this.formData.fromDate = moment(this.startDate + ' ' + this.time).format('YYYY/MM/DD HH:mm:ss')
        this.formData.toDate = moment(this.endDate + ' ' + this.time).format('YYYY/MM/DD HH:mm:ss')
        if (!this.valid) {
          return this.errMsg('Fill all form details')
        }
        if (_.isNull(this.formData.fromDate) || _.isNull(this.formData.toDate)) {
          return this.errMsg('Date is required')
        }
        if (_.isEmpty(this.selectedStaff)) {
          return this.errMsg('Add teachers')
        } else {
          this.formData.trainingStaffs = this.selectedStaff
        }
        if (this.selectedcenters) {
          this.formData.franchiseeID = _.map(this.selectedcenters, 'id')
        } else {
          this.formData.franchiseeID = ''
        }
        this.formData.trainingStaffs = _.map(this.formData.trainingStaffs, 'userStaff.id')
        let transection
        let message = null
        if (!this.enrollID) {
          transection = http.post(`${constants.API_URL}/api/teacher-training/request/create`, this.formData)
          message = 'Enrollment request sent successfully!'
        } else {
          this.formData.id = this.enrollID
          transection = http.post(`${constants.API_URL}/api/teacher-training/request/update`, this.formData)
          message = 'Enrollment request updated successfully!'
        }

        if (transection) {
          this.isLoading = true
          await transection
          this.isLoading = false
          this.$buefy.dialog.alert({
            message: message,
            type: 'is-success'
          })
          this.$router.push({ name: 'teacherEnrollment' })
        } else {
          return
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getStateCityDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(`${constants.API_URL}/api/states`)
        this.stateData = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getTrainingTopicData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/teacher-training/training/get-by-class/${this.formData.classID}`)
        this.isLoading = false
        this.trainingTopicData = data
        if (this.trainingID) {
          this.formData.trainingID = this.trainingID
        }
        await this.getClassList(this.formData.classID)
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getClassList: async function (classGroupID) {
      this.hasClicked = true
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/student/get-selected-classgroup-mapping/${classGroupID}`)
        this.mappingData = data
        let selectedClassObj = []
        if (this.mappingData) {
          const objectArray = Object.entries(this.mappingData)
          objectArray.forEach(([key, value]) => {
            value.studentClasses.map(function (k) {
              selectedClassObj.push(k.name)
            })
          })
          this.getList = selectedClassObj
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Class Group Mapping: ${errorMessage}`)
      }
    },
    getFranchiseeData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.isLoading = false
        this.franchiseeData = data.rows
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getClassData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/student/getclass-group`)
        this.isLoading = false
        data = _.filter(data, e => {
          return e.type === constants.ClassGroupTypes.teacherTraining && e.isActive === true
        })
        this.classData = data
        if (this.classID) {
          this.formData.classID = this.classID
          await this.getTrainingTopicData()
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#abcd{
  color:rgba(0,0,0,.6) ;
  font-size: 16px;
}
</style>
